import { scpConfigService } from "../services/scpConfigService";

import { show as showAlert } from "../../Notifications/actions/alert.actions";

import { message } from "../../../constants/app.constants";

import {
  scpEmvProfileConstants,
  nameSpace
} from "../constants/scpEmvProfileCode.constants";

///============Get EMV PROFILE CODE configuration DATA===============///

export const getEmvProfile = (issuerCode, cardProfileName) => {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await scpConfigService.getAllEmvProfileCode({
        issuerCode: issuerCode.issuerCode,
        profileName: cardProfileName
      });
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        showAlert(
          "danger",
          "Failed to get emv configuration",
          error ? error.message : message.GENERIC_ERROR
        )
      );
    }
  };
  function request(request) {
    return {
      type: scpEmvProfileConstants[`GET_${nameSpace}_REQUEST`],
      request
    };
  }
  function success(response) {
    return {
      type: scpEmvProfileConstants[`GET_${nameSpace}_SUCCESS`],
      response
    };
  }
  function failure(error) {
    return { type: scpEmvProfileConstants[`GET_${nameSpace}_FAILURE`], error };
  }
};

export const resetEMVConfigs = () => {
  return { type: scpEmvProfileConstants[`GET_${nameSpace}_RESET`] };
}